module.exports = __webpack_public_path__ + "e4d41e485b60571f71e682bc2ef94945.jpg";